{
	"allTypes": "All Types",
	"ariaDelete": "Delete",
	"ariaStyleReferencesTypeMenu": "Style References Type Menu",
	"customReferencesInfo": "These are references explicitly added to the style by the user.",
	"deleteNSelected": "Delete {{count}} Selected References",
	"deleteReferencesMessage": "Removing these references may affect the AI Style's overall look and colors. Are you sure you want to continue?",
	"deleteReferencesTitle": "Delete Reference Images",
	"editReferences": "Edit References",
	"noSystemReferences": "No system reference images available. ",
	"noUserReferences": "No user reference images available.",
	"referenceImages": "Reference Images",
	"referenceImagesCount": "Reference Images ({{count}})",
	"selectImagesToDelete": "Select Images to Delete",
	"sharedStyleWarning": "This is a shared style. This will affect all users who use this style.",
	"showAllReferences": "Show All AI Style References",
	"showCustomReferences": "Show Custom AI Style References",
	"showSystemReferences": "Show System AI Style References",
	"systemReferences": "System References",
	"systemReferencesInfo": "These are references intelligently added to the style during editing.",
	"unableToDeleteAllMessage": "A style must contain at least one reference image. Please keep at least one and try again.",
	"unableToDeleteAllTitle": "Unable to Delete All Reference Images",
	"userReferences": "User References"
}
